const TiaraService = (function(){
  // 비공개 변수
  let _service;
  const isProductionMode = process.env.NODE_ENV === 'production';

  const config = {
    svcDomain: 't-fac.co.kr',
    deployment: isProductionMode ? 'production' : 'dev',
  };
  const TiaraTracker = global.TiaraTracker;

  TiaraTracker
    .getInstance()
    .init(config)
    .setSection('brand/PC');

  function init() {
    // 공개 함수 / 변수
    return {
      trackPage(pageName) {
        TiaraTracker.getInstance()
          .setPage(pageName);

        TiaraTracker.getInstance()
          .trackPage(`${pageName}_진입`)
          .track();
      },
      trackEvent(eventName) {
        TiaraTracker.getInstance()
          .trackEvent(eventName)
          .track();
      }
    }
  }

  return {
    getService() {
      if(!_service) {
        _service = init();
      }
      return _service;
    }
  }
})();

export default TiaraService;
